import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CurrentCycleContent } from '../common/model/dto/current-cycle-content';
import { updateCurrentCycleContentById } from '../services/admin/admin-current-cycle-content.service';

export function useAdminCurrentCycleContentMutations(
  currentCycleContentId: string
) {
  const qc = useQueryClient();
  const invalidateCurrentCycleContent = () =>
    qc.invalidateQueries({
      queryKey: ['current-cycle-content', currentCycleContentId],
    });

  const updateCurrentCycleContent = useMutation({
    mutationFn: (updates: Partial<CurrentCycleContent>) =>
      updateCurrentCycleContentById(currentCycleContentId, updates),
    onSuccess: invalidateCurrentCycleContent,
  });

  return {
    updateCurrentCycleContent,
  };
}
